import DOMPurify from 'dompurify'

export const isFullDocument = (html: string): boolean => {
  return /<!doctype\s+html/i.test(html) || /<html(?:\s|>)/i.test(html)
}

export const getUtf8ByteLength = (value: string): number => {
  return new TextEncoder().encode(value).length
}

/**
 * Sanitize assistant-authored HTML before it reaches the isolated frame.
 * The DOM root is retained so document assembly can happen without a second
 * parse/serialize round trip.
 */
export const sanitizeHtmlSnippet = (html: string): HTMLHtmlElement => {
  return DOMPurify.sanitize(html, {
    WHOLE_DOCUMENT: true,
    RETURN_DOM: true,
    FORBID_TAGS: ['base'],
    ALLOW_UNKNOWN_PROTOCOLS: false,
  }) as unknown as HTMLHtmlElement
}

export const hasRenderableHtml = (root: HTMLHtmlElement): boolean => {
  const body = root.querySelector('body')
  const head = root.querySelector('head')

  return Boolean(
    body?.children.length ||
      body?.textContent?.trim() ||
      head?.querySelector('style, title, link, meta')
  )
}
